module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-skeleton"
  }, [_c('div', {
    staticClass: "ushk-skeleton-list"
  }, [_c('div', {
    staticClass: "ushk-skeleton-message"
  }, [_c('div', {
    staticClass: "ushk-skeleton-h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-time"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-b"
  }, [_c('div', {
    staticClass: "ushk-skeleton-message-tag"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-message-text"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-imagetext"
  }, [_c('div', {
    staticClass: "ushk-skeleton-h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-time"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-b"
  }, [_c('div', {
    staticClass: "ushk-skeleton-imagetext-text"
  }, [_c('div', {
    staticClass: "ushk-skeleton-imagetext-text-inner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-imagetext-attach"
  }, [_c('div', {
    staticClass: "ushk-skeleton-imagetext-img"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data"
  }, [_c('div', {
    staticClass: "ushk-skeleton-h"
  }, [_c('div', {
    staticClass: "ushk-flash_icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-time"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-b"
  }, [_c('div', {
    staticClass: "ushk-skeleton-data-des"
  }, [_c('div', {
    staticClass: "ushk-skeleton-data-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-text"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-detail-wrap"
  }, [_c('div', {
    staticClass: "ushk-skeleton-data-vote"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-publish"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-tag"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-country"
  }), _vm._v(" "), _c('div', {
    staticClass: "ushk-skeleton-data-pubdate"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82677e8a","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/Skeleton.vue
// module id = Ew40
// module chunks = 1